import { useSessionStorage } from '@vueuse/core'
import { useFetch } from '#app'
import { useCookie } from '#imports'

import { AuthStorage, tokenManager } from '../utils/tokens'

//TODO: This prevents a git push and seems to not be referenced so this should be removed eventually
// const mergeOptions = (opts: any) => {
//   return {
//     ...opts,
//     headers: {
//       ...opts?.headers,
//       Authorization: `Bearer ${tokenManager.getAccessToken()}`,
//     },
//   }
// }

export { AuthStorage, tokenManager }

export const useServerAccessToken = () =>
  useCookie<string | null>('@rialtic/accessToken', {
    default: () => null,
    httpOnly: true,
    maxAge: 900,
    ...(!import.meta.dev
      ? {
          secure: true,
          domain: 'rialtic.app',
        }
      : {
          sameSite: 'none',
        }),
  })

export const useClientAccessToken = () =>
  useSessionStorage<string | null>('@rialtic/accessToken', null)

export const useAccessToken = () =>
  process.client ? useClientAccessToken() : useServerAccessToken()
